import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import 'jspdf-autotable';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { RepaymentsService } from './../../../services/repayments.service';
// import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-repayment-by-usertype',
  templateUrl: './repayment-by-usertype.component.html',
  styleUrls: ['./repayment-by-usertype.component.css'],
})
export class RepaymentByUsertypeComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  filterWnameArr: Array<any> = [];
  fromDate: any;
  toDate: any;
  cmaShow: boolean = true;
  whrShow: boolean;
  loanShow: boolean;
  loanDataToShow: any;
  valMsgRS: boolean = false;
  isFilterSet: boolean = false;
  loanAppsLoaded: Boolean = false;

  constructor(
    private lservice: RepaymentsService // private ngxLoader: NgxUiLoaderService
  ) {}

  ngOnInit() {
    let obj = {
      fromDate: this.fromDate,
      toDate: this.toDate,
      type: 'by-date',
    };
    this.loanAppsLoaded = false;
    this.lservice.RepaymentbyUser(obj).subscribe((data) => {
      // this.ngxLoader.start();
      this.loanAppsLoaded = true;
      this.dataRec = true;
      if (data['success']) {
        this.lApplications = data['data'];
        this.dataToShow = data['data'];
        for (let i = 0; i < this.dataToShow.length; i++) {
          // this.dataToShow[i]['tprice'] = this.dataToShow[i]['depositQuantity'].match(/\d+/g) * this.dataToShow[i]['depositApp']['perUnitValue'];
          this.dataToShow[i]['tprice'] =
            this.dataToShow[i]['depositApp']['depositQty'] *
            this.dataToShow[i]['depositApp']['perUnitValue'];
          if (
            !this.isInArray(
              this.lApplications[i]['warehouseName'],
              this.filterWnameArr
            )
          ) {
            this.filterWnameArr.push(this.lApplications[i]['warehouseName']);
          }
        }
        // this.ngxLoader.stop();
      }
    });
  }

  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }

  whrData(obj) {
    // this.ngxLoader.start();
    this.loanAppsLoaded = true;

    this.cmaShow = false;
    this.whrShow = true;
    this.loanShow = false;
    let json = {
      userType: obj._id[0],
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
    this.lservice.RepaymentbyUserTypeWhr(json).subscribe((data) => {
      this.dataRec = true;
      this.loanAppsLoaded = true;
      if (data['success']) {
        this.whrData = data['data'];
        // this.ngxLoader.stop();
      }
    });
  }

  loanData(obj) {
    // this.ngxLoader.start();
    this.loanAppsLoaded = true;
    this.cmaShow = false;
    this.whrShow = false;
    this.loanShow = true;
    let json = {
      wId: obj._id[0],
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
    this.lservice.RepaymentbyWhrLoans(json).subscribe((data) => {
      this.dataRec = true;
      this.loanAppsLoaded = true;
      if (data['success']) {
        this.loanDataToShow = data['data'];
        // this.ngxLoader.stop();
      }
    });
  }

  filterByDate() {}

  removeFilter() {}
}
